define([
    "jquery",
    "underscore",
    "marionette"
], function($, _, Marionette) {
    var FormErrorsBehavior = Marionette.Behavior.extend({
        ui:{
            'successBox': '.success_box',
            'errorBox': '.error_box',
            'errorMsg': '.error_box span'
        },

        onShowSuccess: function( successMessage ){
            var that = this;

            // First hide the previously displayed errors
            this.onHideErrors();

            this.$(this.ui.successBox).show();
            this.$(this.ui.successBox)[0].scrollIntoView(true);

            if( successMessage != undefined && successMessage != null){
                this.$(this.ui.successBox).find("span").html(successMessage);
            }

            /*
            setTimeout(function(){
                that.onHideSuccess();
            }, 10000);
            */
        },

        onHideSuccess: function(){
            this.$(this.ui.successBox).hide();
        },

        /**
         * Display forms error
         *
         * @param   {array} errors An array of errors: {errorName: "errorText"}. errorName should match the HTML attribute AND the model's attribute's name.
         */
        onShowErrors: function(errors) {
            var that = this;

            // First hide the previously displayed errors
            this.onHideErrors();

            const scrollIntoViewOptions = {behavior: "smooth", block: "center", inline: "nearest"};

            _.each(errors, function (errorText, error) {
                if(error !== "error_message"){
                    if(that.$(".help-error[for='"+error+"']")[0]){
                        that.$('#'+error).closest('.form-group').addClass('has-error');
                        that.$(".help-error[for='"+error+"']").text(errorText);
                        that.$(".help-error[for='"+error+"']").show();
                        if(that.$(".help-error[for='"+error+"']")[0]){
                            that.$(".help-error[for='" + error + "']")[0].scrollIntoView(scrollIntoViewOptions);
                        }
                    }else{
                        that.$(that.ui.errorBox).show();
                        that.$(that.ui.errorMsg).html(errorText);
                        if(that.$(that.ui.errorBox)[0]){
                            that.$(that.ui.errorBox)[0].scrollIntoView(scrollIntoViewOptions);
                        }
                    }
                }else{
                    that.$(that.ui.errorBox).show();
                    that.$(that.ui.errorMsg).html(errorText);
                    if(that.$(that.ui.errorBox)[0]){
                        that.$(that.ui.errorBox)[0].scrollIntoView(scrollIntoViewOptions);
                    }
                }

                that.errorElements.push(error);
            });
        },

        /**
         * Hide previously displayed errors
         */
        onHideErrors: function () {
            var that = this;
            this.$(this.ui.errorBox).hide();
            this.$(this.ui.errorMsg).html('');

            _.each(this.errorElements, function(element){
                that.$('#'+element).closest('.form-group').removeClass('has-error');
                that.$(".help-error[for='"+element+"']").text('');
                that.$(".help-error[for='"+element+"']").hide();
            });

            this.errorElements = [];
        }
    });

    return FormErrorsBehavior;
});
